import { Environments } from '@/config';
import { UserRole, PartnerOrganization } from '@modules/core/types';
import { PartnerPermission, Permissions } from '../types';
import { HELIX } from './helix';
import { HELIX_HEALTH_PARTNERS } from './helix-health-partners';
import { HELIX_LCMC } from './helix-lcmc';
import { HELIX_RENOWN } from './helix-renown';
import { HELIX_WELLSPAN } from './helix-wellspan';
import { HELIX_OSUWMC } from './helix-osuwmc';
import { HELIX_MHHS } from './helix-mhhs';
import { HELIX_MUSC } from './helix-musc';
import { HELIX_NEBRASKA } from './helix-nebraska';
import { HELIX_WAKEMED } from './helix-wakemed';
import { HELIX_SANFORD } from './helix-sanford';
import { HELIX_CONE } from './helix-cone';
import { HELIX_PARKVIEW } from './helix-parkview';
import { HELIX_ROCHESTER } from './helix-rochester';
import { HELIX_TRIHEALTH } from './helix-trihealth';
import { HELIX_UHN } from './helix-uhn';
import { HEALTH_PARTNERS } from './health-partners';
import { LCMC } from './lcmc';
import { RENOWN } from './renown';
import { WELLSPAN } from './wellspan';
import { OSUWMC } from './osuwmc';
import { MUSC } from './musc';
import { NEBRASKA } from './nebraska';
import { WAKEMED } from './wakemed';
import { SANFORD } from './sanford';
import { CONE } from './cone';
import { TRIHEALTH } from './trihealth';
import { PARKVIEW } from './parkview';
import { ROCHESTER } from './rochester';
import { MHHS } from './mhhs';
import { UHN } from './uhn';

const adminRole = UserRole.ADMINISTRATOR;
const executiveRole = UserRole.EXECUTIVE;
const memberRole = UserRole.MEMBER;
const memberLimitedPhiRole = UserRole.MEMBER_LIMITED_PHI;

// Partners
let MYRTLE, ST_LUKE;

// Helix Partners
let HELIX_MYRTLE, HELIX_ST_LUKE;

if (import.meta.env.MODE !== Environments.PROD) {
  /**
   *  Partners Permissions Staging and Platform Development
   **/

  MYRTLE = {
    [adminRole]: [
      Permissions.GENETIC_COUNSELING,
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
    [executiveRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberLimitedPhiRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberRole]: [
      Permissions.GENETIC_COUNSELING,
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
  };

  HELIX_MYRTLE = {
    [adminRole]: [
      Permissions.GENETIC_COUNSELING,
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
    [executiveRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberLimitedPhiRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberRole]: [
      Permissions.GENETIC_COUNSELING,
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
  };

  ST_LUKE = {
    [adminRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
    ],
    [executiveRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3],
    [memberLimitedPhiRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3],
    [memberRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
    ],
  };

  HELIX_ST_LUKE = {
    [adminRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
      Permissions.CAMPAIGN_TRACKING,
    ],
    [executiveRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAMPAIGN_TRACKING,
    ],
    [memberLimitedPhiRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAMPAIGN_TRACKING,
    ],
    [memberRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
      Permissions.CAMPAIGN_TRACKING,
    ],
  };
} else {
  /**
   *  Partners Permissions Production
   **/

  MYRTLE = {
    [adminRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.GENETIC_COUNSELING,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
    [executiveRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberLimitedPhiRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.GENETIC_COUNSELING,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
  };

  HELIX_MYRTLE = {
    [adminRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.GENETIC_COUNSELING,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
    [executiveRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberLimitedPhiRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.GENETIC_COUNSELING,
      Permissions.CDC_TIER1_METRICS,
      Permissions.CAN_VIEW_PHI,
    ],
  };

  ST_LUKE = {
    [adminRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
    ],
    [executiveRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberLimitedPhiRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
    ],
  };

  HELIX_ST_LUKE = {
    [adminRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
    ],
    [executiveRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberLimitedPhiRole]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS],
    [memberRole]: [
      Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
      Permissions.CDC_TIER1_METRICS,
      Permissions.GENETIC_COUNSELING,
      Permissions.GENETIC_COUNSELING__CREATE,
      Permissions.CAN_VIEW_PHI,
    ],
  };
}

const BUILDER_SVC_TEST = {
  [adminRole]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAN_VIEW_PHI,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
  ],
};

export const PERMISSIONS: Record<string, PartnerPermission> = {
  [PartnerOrganization.HELIX]: HELIX,
  // Mirror apps
  [PartnerOrganization.HELIX_CONE]: HELIX_CONE,
  [PartnerOrganization.HELIX_SANFORD]: HELIX_SANFORD,
  [PartnerOrganization.HELIX_HEALTH_PARTNERS]: HELIX_HEALTH_PARTNERS,
  [PartnerOrganization.HELIX_LCMC]: HELIX_LCMC,
  [PartnerOrganization.HELIX_MEMORIAL_HERMANN]: HELIX_MHHS,
  [PartnerOrganization.HELIX_MYRTLE]: HELIX_MYRTLE,
  [PartnerOrganization.HELIX_MUSC]: HELIX_MUSC,
  [PartnerOrganization.HELIX_NEBRASKA]: HELIX_NEBRASKA,
  [PartnerOrganization.HELIX_RENOWN]: HELIX_RENOWN,
  [PartnerOrganization.HELIX_ST_LUKE]: HELIX_ST_LUKE,
  [PartnerOrganization.HELIX_WELLSPAN]: HELIX_WELLSPAN,
  [PartnerOrganization.HELIX_OSUWMC]: HELIX_OSUWMC,
  [PartnerOrganization.HELIX_WAKEMED]: HELIX_WAKEMED,
  [PartnerOrganization.HELIX_TRIHEALTH]: HELIX_TRIHEALTH,
  [PartnerOrganization.HELIX_PARKVIEW]: HELIX_PARKVIEW,
  [PartnerOrganization.HELIX_ROCHESTER]: HELIX_ROCHESTER,
  [PartnerOrganization.HELIX_UHN]: HELIX_UHN,
  // Partner apps
  [PartnerOrganization.CONE]: CONE,
  [PartnerOrganization.SANFORD]: SANFORD,
  [PartnerOrganization.HEALTH_PARTNERS]: HEALTH_PARTNERS,
  [PartnerOrganization.LCMC]: LCMC,
  [PartnerOrganization.MEMORIAL_HERMANN]: MHHS,
  [PartnerOrganization.MYRTLE]: MYRTLE,
  [PartnerOrganization.MUSC]: MUSC,
  [PartnerOrganization.NEBRASKA]: NEBRASKA,
  [PartnerOrganization.RENOWN]: RENOWN,
  [PartnerOrganization.ST_LUKE]: ST_LUKE,
  [PartnerOrganization.WELLSPAN]: WELLSPAN,
  [PartnerOrganization.OSUWMC]: OSUWMC,
  [PartnerOrganization.WAKEMED]: WAKEMED,
  [PartnerOrganization.TRIHEALTH]: TRIHEALTH,
  [PartnerOrganization.PARKVIEW]: PARKVIEW,
  [PartnerOrganization.ROCHESTER]: ROCHESTER,
  [PartnerOrganization.UHN]: UHN,
  [PartnerOrganization.BUILDER_SVC_TEST]: BUILDER_SVC_TEST,
};
